var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8053 25.6009L13.2712 27.0668C13.8666 27.6621 14.8317 27.6621 15.4272 27.0668L16.8929 25.6009C17.3106 25.1832 17.8762 24.9497 18.4665 24.9497H19.569C21.812 24.9497 23.6306 23.1311 23.6306 20.8869V13.7549C23.6306 11.512 21.812 9.69336 19.569 9.69336H9.13051C6.88637 9.69336 5.06769 11.512 5.06769 13.7549V20.8869C5.06769 23.1311 6.88637 24.9497 9.13051 24.9497H10.2318C10.8221 24.9497 11.3876 25.1832 11.8053 25.6009Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.5052 9.6937V8.65594C10.5052 6.41438 12.3213 4.59961 14.5718 4.59961H25.0105C27.252 4.59961 29.0681 6.41438 29.0681 8.65594V15.7892C29.0681 18.0398 27.252 19.8546 25.0105 19.8546H23.9092C23.8157 19.8546 23.7236 19.865 23.6302 19.8741",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2722 17.4941V17.5872M17.6494 17.5141C17.6494 17.7236 17.4794 17.8934 17.2699 17.8934C17.0604 17.8934 16.8907 17.7236 16.8907 17.5141C16.8907 17.3045 17.0604 17.1348 17.2699 17.1348C17.4794 17.1348 17.6494 17.3045 17.6494 17.5141Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0248 17.4941V17.5872M11.4019 17.5141C11.4019 17.7236 11.232 17.8934 11.0225 17.8934C10.813 17.8934 10.6432 17.7236 10.6432 17.5141C10.6432 17.3045 10.813 17.1348 11.0225 17.1348C11.232 17.1348 11.4019 17.3045 11.4019 17.5141Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChat);
export default __webpack_public_path__ + "static/media/double-chat.f8ad954e.svg";
export { ForwardRef as ReactComponent };